import * as React from 'react';
import { useSelector } from 'react-redux';

import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';

import { datasetSharesSelectors } from 'companion-app-components/flux/dataset-shares';

import { stringAvatar } from './utils';

interface ProfileAvatarProps {
  datasetId: string;
}

const ProfileAvatar: React.FC<ProfileAvatarProps> = ({ datasetId }) => {

  const sharedWith = useSelector((state) => datasetSharesSelectors.getSharesByDatasetId(state, datasetId));
  const sharedWithList = sharedWith?.valueSeq?.().toArray?.();

  if (sharedWithList.length > 0) {
    const maxAvatars = 2;
    const visibleShares = sharedWithList.slice(0, maxAvatars);
    const extraCount = sharedWithList.length - maxAvatars;
    return (
      <Box display="inline-flex" alignItems="center">
        {visibleShares.map((share, index) => {
          const fullName = `${share.granteeFirstName?.trim() ?? ''} ${share.granteeLastName?.trim() ?? ''}`.trim();
          const avatarProps = stringAvatar(fullName);
          return (
            <Avatar
              key={share.id ?? fullName ?? index}
              {...avatarProps}
              sx={{
                ...avatarProps.sx,
                marginLeft: index === 0 ? '16px' : '4px',
              }}
            />
          );
        })}
        {extraCount > 0 && (
          <Avatar
            sx={{
              width: 28,
              height: 28,
              fontSize: 12,
              marginLeft: '4px',
              color: 'shadowGrey',
              fontWeight: 500,
            }}
          >
            {`+${extraCount}`}
          </Avatar>
        )}
      </Box>
    );
  }
  return null;
};

export default ProfileAvatar;
